type ContestFormData = {
  contest: Array<{ question?: string; answers?: string[] }>;
  files?: File[];
  contest_id?: string;
};

function isContestFormData(data: unknown): data is ContestFormData {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  const d = data as Record<string, unknown>;
  return !("contest" in d) || Array.isArray(d.contest);
}

export const contestsFormDataBodySerializer = (data: unknown): FormData => {
  if (!isContestFormData(data)) {
    throw new Error("contestsFormDataBodySerializer: unexpected data shape");
  }

  const { contest, files, contest_id } = data;
  const formData = new FormData();

  contest?.forEach((entry, i) => {
    if (entry.question) {
      formData.append(`contest[${i}][question]`, entry.question);
    }
    entry.answers?.forEach((answer, j) => {
      formData.append(`contest[${i}][answers][${j}]`, answer);
    });
  });

  files?.forEach((file, i) => {
    formData.append(`files[${i}]`, file);
  });

  if (contest_id) {
    formData.append("contest_id", contest_id);
  }

  return formData;
};
